<div class="container-fluid" *ngIf="featureSet">
  <div class="row justify-content-start">
    <div class="col-md-8 col-xs-12">
      <div class="mt-3" name="timeSpan" aria-label="Time Span">
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'weekly' ? 'active' : ''" value="weekly" (click)="changeTimeSpan('weekly')">Weekly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'monthly' ? 'active' : ''" value="monthly" (click)="changeTimeSpan('monthly')">Monthly</mat-button-toggle>
        <mat-button-toggle class="lw-toggle-btn" [ngClass]="this.timespan === 'custom' ? 'active' : ''" value="custom" (click)="changeTimeSpan('custom')">Custom</mat-button-toggle>
      </div>
      <lds-feature-list [features]="features" [data]="features" [productCode]="featureSet.productCode" deviceType="switch" *ngIf="features"></lds-feature-list>
      <div class="left-graph-container" [ngSwitch]="deviceType">
        <div *ngSwitchCase="'mag_trigger'">
          <table  class="detail-table">
            <tr>
              <th>Date</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let data of switchData">
              <td>{{data.displayTime}}</td>
              <td>{{data.value === 1 ? 'Open' : 'Closed'}}</td>
            </tr>
          </table>
        </div>
        <lds-y3-switch-graphs [timespan]="timespan" [status]="status" [data]="switchData" *ngSwitchDefault [startTime]="startTime" [endTime]="endTime"></lds-y3-switch-graphs>
        <div class="below-graph">
          <button class="lds-btn" (click)="onExportClick()">Export Data</button>
        </div>
        <div class="below-graph-text">
          <p>Click and drag to zoom.</p>
        </div>
      </div>
    </div>
    <div class="pl-md-0 col-md-4 pt-md-4 pt-3 col-xs-12 mb-2">
        <div class="info-container py-2 text-center mb-2">

            <div class="icon">
                <i class="{{ icons.getIcon(user.findVirtualProductCode(featureSet)) }}"></i>
            </div>
            <div class="productcode-box">
                {{displayProductCode(featureSet.productCode)}}
            </div>
        </div>
      <div class="mx-2 mx-md-0">
        <div class="pie-chart-container pt-2 mb-2">
          <div class="mx-4">Switch Total On Time / {{this.timespan}}</div>
          <hr class="mx-2 my-2">
          <lds-y3-donut-chart [timespan]="this.timespan" [data]="totalOnData" [status]="status" *ngIf="totalOnData"></lds-y3-donut-chart>
        </div>
        <div *ngIf="showLinkBtns" class="btn-container" >
          <button class="lds-btn active">Switch Use</button>
          <button class="lds-btn"  (click)="changeRoute()">Energy Use</button>
        </div>
        <!-- <div class="pie-chart-container bar-container pt-2 mb-2">
          <div class="mx-4">Hourly Average Consumption</div>
          <hr class="mx-2 my-2">
          <lds-y3-bar-chart [data]="hourlyAverage" *ngIf="hourlyAverage"></lds-y3-bar-chart>
        </div> -->

      </div>
    </div>
  </div>
</div>
